import styled from 'styled-components'

export const ContentBanner = styled.div`
    background-color: #f4f4f5;
    padding: 8px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.15);
    gap: 10px;
    flex-direction: column;

    .cookie-info {
        font-size: 12px;
        color: #000;
        text-align: center;
        width: 80%;
    }
    .cookie-content-btns {
        display: flex;
        gap: 10px;
        width: 80%;
    }

    @media screen and (min-width: 992px) {
        flex-direction: row;
        .cookie-info {
            text-align: justify;
            width: 64%;
        }
        .cookie-content-btns {
            width: 18%;
        }
    }
`
